import { motion } from 'motion/react';
import React from 'react';

import { Flex, Paragraph, Text } from '~/styles';

import { HintLink } from './HintLink';

interface CheckYourEmailProps {
  description?: string;
  footerLabel?: string;
  onFooterClick?: () => void;
}

export const CheckYourEmail: React.FC<CheckYourEmailProps> = ({
  description = "We've sent a sign-in link to your inbox to make sure it's you.",
  footerLabel,
  onFooterClick,
}) => (
  <motion.div
    initial={{ opacity: 0, y: 4 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
  >
    <Flex flexDirection="column" gap={8}>
      <Text size={16} weight="semibold">
        Check your email
      </Text>
      <Paragraph>{description}</Paragraph>
      {footerLabel && onFooterClick && (
        <Flex justifyContent="center" mt={24}>
          <HintLink onClick={onFooterClick}>{footerLabel}</HintLink>
        </Flex>
      )}
    </Flex>
  </motion.div>
);
